// extracted by mini-css-extract-plugin
export default {"mainWrapper":"ConfigMembershipCNCCategoryAndServices_mainWrapper__aWGbJ","mainContainer":"ConfigMembershipCNCCategoryAndServices_mainContainer__Ijeuj"};